import { useState, useEffect, memo } from 'react';
import { Snackbar, Link, Button, Box } from '@mui/material';
import './CookieBanner.scss';

const CookieBanner = memo(() => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setOpen(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      className="cookie-banner"
      message={
        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
          <span>
            We use cookies and analytics to improve your experience. See our{' '}
            <Link href="/privacy-policy" target="_blank" underline="always" color="inherit" style={{ cursor: 'pointer' }}>
              Privacy Policy
            </Link>{' '}
            for details.
          </span>
        </Box>
      }
      action={
        <Button
          size="small"
          onClick={handleAccept}
          sx={{ color: '#000', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase' }}
        >
          Accept
        </Button>
      }
    />
  );
});

export default CookieBanner;
